/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react';
import MillenniumRealmSelector from './MillenniumRealmSelector.react';
import ApplicationFooter from '../ApplicationFooter/ApplicationFooter.react';
import './login.scss';
import CernerLogo from './Cerner_Logo.png';

/**
 * Application Login
 *
 */
class Login extends Component {
	constructor(props) {
		super(props);
		this.handleMillenniumRealmChange = this.handleMillenniumRealmChange.bind(this);
		this.handleMillenniumRealmSelection = this.handleMillenniumRealmSelection.bind(this);
		this.state = {
			realmSelector: null
		};
	}

	handleMillenniumRealmChange(e) {
		this.setState(() => ({
			realmSelector: e
		}));
	}

	handleMillenniumRealmSelection(e) {
		e.preventDefault();
	}

	render() {
		return (
			<main className='form-signin bg-light'>
				<img src={CernerLogo} alt='Cerner Logo' className='mb-3 logo' />
				<div className='card mb-3'>
					<div className='card-header'>
						Login with
						{' '}
						<i>Cerner Millennium</i>
					</div>
					<div className='card-body'>
						<p className='card-text'>
							Have a
							{' '}
							<i>Cerner Millennium</i>
							{' '}
							account? Use your account to access
							{' '}
							<b>Cerner Care Notifications</b>
							{' '}
							by searching for your organization and selecting a Cerner Millennium log-in.
						</p>
						<div className='text-left'>
							<MillenniumRealmSelector
								onChange={this.handleMillenniumRealmChange}
								value={this.state.realmSelector}
								name='realmId'
								id='millenniumRealmId'
							/>
						</div>
						<a className='btn btn-primary mb-2 mt-4' href={`/login/openid?endpoint=${this.state.realmSelector && this.state.realmSelector.value}`}>
							Login with
							{' '}
							<i>Cerner Millennium</i>
						</a>
					</div>
				</div>

				<div className='card mb-3'>
					<div className='card-header'>
						Login with
						{' '}
						<i>CernerCare</i>
					</div>
					<div className='card-body'>
						<p className='card-text'>
							Use
							{' '}
							<i>CernerCare</i>
							{' '}
							if your organization has not configured a provider.
						</p>
						<a className='btn btn-primary mb-2' href='/login/openid?endpoint=cernercare'>
							Login with
							{' '}
							<i>CernerCare</i>
						</a>
					</div>
				</div>
				<div className='dropdown-divider mt-4' />
				<a className='btn btn-secondary mt-2' href='/oauth2/authorization/sso'>
					Login with
					{' '}
					<i>Oracle Associates</i>
				</a>
				<ApplicationFooter />
			</main>
		);
	}
}

export { Login as default };